/**
 * The member's account credit stopped covering their purchase between the quote and the
 * click — read off the ENVELOPE (internalapi-envelope shape), like `getPaymentTimingChange`.
 *
 * The server refuses with `credit_balance_changed` when the quote said credit covered the
 * purchase, so no card was sent, and the balance has since been spent (credits D30).
 * Nothing was booked or charged; the step's answer is to re-quote, so the card step
 * returns, and show the server's member copy.
 *
 * @module lib/apiClient/creditBalanceChanged
 */

import type { ApiErrorResult } from './types';

/** The member copy when the failure envelope is a stale-credit refusal, otherwise null. */
export function getCreditBalanceChange(result: ApiErrorResult): string | null {
  return result.error?.code === 'credit_balance_changed' ? result.message : null;
}
